export function loadMoreIngredients(){
    let holder_ingredients = $('.ingredients-hidden');
    holder_ingredients.on('click', '.load-more', function (e) {
        e.preventDefault();

        let $this = $(this);
        let paged = $this.attr('data-paged');
        let data = {
            'action': 'load_ingredients',
            'category': $this.attr('data-category'),
            'paged': ++paged
        };

        $.ajax({
            url: ajaxvars.ajaxurl,
            data: data,
            type: 'POST',
            beforeSend: function () {
                $this.text('loading');
            },
            success: function (response) {
                $this.parent().prev().append(response);

                $this.attr('data-paged', paged);
                if (paged == $this.attr('data-max-pages')) {
                    $this.parent().hide();
                }
            },
            complete: function () {
                $this.text('load more');
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/loadMoreIngredients.js